// src/pages/yachts/special-offers/redux/_actions.js
import axios from 'axios';
import { API_URL } from '../../../../helpers/variables';
import { errorHandler, successHandler } from '../../../../helpers/alerts';
import { authConfig } from '../../../../helpers/authConfig';

import {
    FETCH_INIT_SPECIAL_OFFERS,
    FETCH_SPECIAL_OFFERS,
    FETCH_SPECIAL_OFFERS_SUCCESS,
    FETCH_SPECIAL_OFFERS_ERROR,
    FETCH_SPECIAL_OFFER,
    FETCH_SPECIAL_OFFER_SUCCESS,
    FETCH_SPECIAL_OFFER_ERROR,
    CREATE_SPECIAL_OFFER,
    CREATE_SPECIAL_OFFER_SUCCESS,
    CREATE_SPECIAL_OFFER_ERROR,
    UPDATE_SPECIAL_OFFER,
    UPDATE_SPECIAL_OFFER_SUCCESS,
    UPDATE_SPECIAL_OFFER_ERROR,
    ARCHIVE_SPECIAL_OFFER,
    ARCHIVE_SPECIAL_OFFER_SUCCESS,
    ARCHIVE_SPECIAL_OFFER_ERROR,
    FETCH_OFFER_YACHT_RATES,
    FETCH_OFFER_YACHT_RATES_SUCCESS,
    FETCH_OFFER_YACHT_RATES_ERROR,
    FETCH_OFFER_YACHT_SEASONS_SUCCESS
} from './_types';

const BASE = '/charter-special-offers';

const isValidationError = (error) => !!error.response && error.response.status === 422;

export const fetchInitSpecialOffers = () => (dispatch) => {
    dispatch({ type: FETCH_INIT_SPECIAL_OFFERS });
    return Promise.resolve();
};

export const fetchSpecialOffers = (yachtId, filters = {}) => (dispatch) => {
    dispatch({ type: FETCH_SPECIAL_OFFERS });
    const params = { yacht_id: yachtId, ...filters };
    return axios
        .get(`${API_URL}${BASE}`, { headers: authConfig(), params })
        .then((response) => {
            const offers = Array.isArray(response.data)
                ? response.data
                : (response.data && response.data.data) || [];
            dispatch({
                type: FETCH_SPECIAL_OFFERS_SUCCESS,
                payload: { yacht_id: yachtId, offers }
            });
            return offers;
        })
        .catch((error) => {
            dispatch({ type: FETCH_SPECIAL_OFFERS_ERROR });
            errorHandler(dispatch, error.response);
        });
};

export const fetchSpecialOffer = (id) => (dispatch) => {
    dispatch({ type: FETCH_SPECIAL_OFFER });
    return axios
        .get(`${API_URL}${BASE}/${id}`, { headers: authConfig() })
        .then((response) => {
            dispatch({
                type: FETCH_SPECIAL_OFFER_SUCCESS,
                payload: response.data
            });
            return response.data;
        })
        .catch((error) => {
            dispatch({ type: FETCH_SPECIAL_OFFER_ERROR });
            errorHandler(dispatch, error.response);
        });
};

export const createSpecialOffer = (payload) => (dispatch) => {
    dispatch({ type: CREATE_SPECIAL_OFFER });
    return axios
        .post(`${API_URL}${BASE}`, payload, { headers: authConfig() })
        .then((response) => {
            dispatch({
                type: CREATE_SPECIAL_OFFER_SUCCESS,
                payload: response.data
            });
            successHandler(dispatch, 'manageSpecialOffer');
            return response.data;
        })
        .catch((error) => {
            dispatch({ type: CREATE_SPECIAL_OFFER_ERROR });
            // 422s are rendered inline by the form; re-throw so the container gets them.
            if (!isValidationError(error)) errorHandler(dispatch, error.response);
            throw error;
        });
};

export const updateSpecialOffer = (id, payload) => (dispatch) => {
    dispatch({ type: UPDATE_SPECIAL_OFFER });
    return axios
        .put(`${API_URL}${BASE}/${id}`, payload, { headers: authConfig() })
        .then((response) => {
            dispatch({
                type: UPDATE_SPECIAL_OFFER_SUCCESS,
                payload: response.data
            });
            successHandler(dispatch, 'manageSpecialOffer');
            return response.data;
        })
        .catch((error) => {
            dispatch({ type: UPDATE_SPECIAL_OFFER_ERROR });
            if (!isValidationError(error)) errorHandler(dispatch, error.response);
            throw error;
        });
};

export const archiveSpecialOffer = (id) => (dispatch) => {
    dispatch({ type: ARCHIVE_SPECIAL_OFFER });
    return axios
        .delete(`${API_URL}${BASE}/${id}`, { headers: authConfig() })
        .then((response) => {
            dispatch({
                type: ARCHIVE_SPECIAL_OFFER_SUCCESS,
                payload: { id }
            });
            successHandler(dispatch, 'archiveSpecialOffer');
            return response.data;
        })
        .catch((error) => {
            dispatch({ type: ARCHIVE_SPECIAL_OFFER_ERROR });
            errorHandler(dispatch, error.response);
            throw error;
        });
};

export const simulateSpecialOffer = (body) => (_dispatch) => {
    return axios
        .post(`${API_URL}${BASE}/simulate`, body, { headers: authConfig() })
        .then((response) => response.data);
};

export const fetchOfferYachtRates = (yachtId) => (dispatch) => {
    dispatch({ type: FETCH_OFFER_YACHT_RATES });
    return axios
        .get(`${API_URL}/yachts/${yachtId}/rates`, { headers: authConfig() })
        .then((response) => {
            const rates = Array.isArray(response.data)
                ? response.data
                : (response.data && response.data.rates) || [];
            dispatch({
                type: FETCH_OFFER_YACHT_RATES_SUCCESS,
                payload: { yacht_id: yachtId, rates }
            });
            return rates;
        })
        .catch((error) => {
            dispatch({ type: FETCH_OFFER_YACHT_RATES_ERROR });
            errorHandler(dispatch, error.response);
        });
};

// Seasons (with their rates and locations) drive which destinations an offer may
// be restricted to — see advertisedLocations.js.
export const fetchOfferYachtSeasons = (yachtId) => (dispatch) => {
    return axios
        .get(`${API_URL}/yachts/${yachtId}/locations`, { headers: authConfig() })
        .then((response) => {
            const seasons = (response.data && response.data.location_seasons) || [];
            dispatch({
                type: FETCH_OFFER_YACHT_SEASONS_SUCCESS,
                payload: { yacht_id: yachtId, seasons }
            });
            return seasons;
        })
        .catch((error) => {
            errorHandler(dispatch, error.response);
        });
};
